import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { FormProps, StepForm } from "./lib/StepForm"

const HunterRegistration = () => {
  const urlParams = useParams<{ hunterId: string }>()
  const [values, setValues] = useState<Record<string, string|number>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'hunter')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf)
    })
    const storageValues = sessionStorage.getItem('hunter')
    if (storageValues) {
      setValues(JSON.parse(storageValues))
      return
    } else {
      getDoc(doc(collection(db, 'hunters'), urlParams.hunterId)).then((_: DocumentSnapshot) => {
        const data = _.data()
        if (data && data.status === "init") {
          setValues(data)
        }
        else {
          window.alert('既に狩猟者情報は登録済みです')
          navigate('/')
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSave = (values: Record<string, string | number>) => {
    setValues(values)
    sessionStorage.setItem('hunter', JSON.stringify(values))
    navigate(`/hunters/${urlParams.hunterId}/confirm`)
  }

  return (
    <StepForm values={values} forms={forms} onSave={onSave} />
  )
}

export default HunterRegistration
